'use client';

import Script from 'next/script';
import coreKeeperSource from 'raw-loader!@mail-core/dashboard/keeper/keeper.min.js';
import userKeeperSource from 'raw-loader!@mail-core/dashboard/keeper/user.min.js';
import coreLoggerSource from 'raw-loader!@mail-core/logger/inline/logger.min.js';
import xraySource from 'raw-loader!@mail/xray/xray.min.js';
import {useLayoutEffect, useState} from 'react';

import {ScriptsInitialization} from './ScriptsInitialization';
import {Props} from './types';

export const Scripts = ({envConfig, userIp, enableLazyScripts}: Props) => {
  const {ANALYTICS_ID, STAGE, YA_METRIKA_ID, NODE_ENV} = envConfig;
  const [isReady, setIsReady] = useState(false);
  const isProduction = STAGE === 'prod';
  const isNpmRunDev = NODE_ENV === 'development';

  useLayoutEffect(() => {
    if (!enableLazyScripts) return;

    const fallbackTimeout = setTimeout(() => {
      onUserInteractive();
    }, 5000);

    const onUserInteractive = () => {
      setIsReady(true);
      clearTimeout(fallbackTimeout);
      document.removeEventListener('mousemove', onUserInteractive);
      document.removeEventListener('touchstart', onUserInteractive);
    };

    document.addEventListener('mousemove', onUserInteractive);
    document.addEventListener('touchstart', onUserInteractive);

    return () => {
      clearTimeout(fallbackTimeout);
      document.removeEventListener('mousemove', onUserInteractive);
      document.removeEventListener('touchstart', onUserInteractive);
    };
  }, []);

  return (
    <>
      <Script id="ya-metrika" strategy="afterInteractive">
        {`
              (function(m, e, t, r, i, k, a) {
                m[i] = m[i] || function() {
                  (m[i].a = m[i].a || []).push(arguments)
                };
                m[i].l = 1 * new Date();
                for (var j = 0; j < document.scripts.length; j++) {
                  if (document.scripts[j].src === r) {
                    return;
                  }
                }
                k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
              })
              (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
              ym("${YA_METRIKA_ID}", "init", {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true,
                ecommerce: "dataLayer",
                defer: true
              });
            `}
      </Script>

      {(isReady || !enableLazyScripts) && (
        <>
          <Script id="my-tracker" strategy="afterInteractive">
            {`
          var _tmr = window._tmr || (window._tmr = []);
          _tmr.push({id: "${ANALYTICS_ID}", type: "pageView", timespent: true, start: (new Date()).getTime()});
          (function (d, w, id) {
            if (d.getElementById(id)) return;
            var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
            ts.src = "https://top-fwz1.mail.ru/js/code.js";
            ts.onload = function () {
              var eventParams = {referrer: d.referrer};
              _tmr.push({id: "${ANALYTICS_ID}", type: "reachGoal", goal: "session_start", params: eventParams});
            };
            var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
            if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
          })(document, window, "topmailru-code");
        `}
          </Script>

          {!isNpmRunDev && (
            <Script id="__core-logger__" strategy="afterInteractive">
              {coreLoggerSource}
            </Script>
          )}

          <Script id="__core-logger-init__" strategy="afterInteractive">
            {`
          window.coreLogger && coreLogger.init({
            preset: 'base',
            presetSource: 'cdn-v0',
            errors: {
              silent: false,
              preset: 'base',
            },
          });
          //# sourceURL=core-logger-init.min.js
        `}
          </Script>

          <Script id="__core-keeper__" strategy="afterInteractive">
            {coreKeeperSource}
          </Script>

          <Script id="__core-keeper-init__" strategy="afterInteractive">
            {`
          window.coreKeeper && coreKeeper.init();
          //# sourceURL=core-keeper-init.js
        `}
          </Script>

          <Script id="__xray__" strategy="afterInteractive">
            {xraySource}
          </Script>

          <Script id="__xray-init__" strategy="afterInteractive">
            {`
          xray.setConfig({
            idle: ${!isProduction},
            defaultParams: {
              p: 'rustore_web',
            },
          });

          xray.send('pk-xray-ready');
          //# sourceURL=xray.init.js
        `}
          </Script>

          <Script id="__user-keeper__" strategy="afterInteractive">
            {userKeeperSource}
          </Script>
          <ScriptsInitialization envConfig={envConfig} userIp={userIp} />
        </>
      )}
    </>
  );
};
